export const ACCEPTED_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const ERROR_KIND = {
    RESHOOT: 'reshoot',
    BUSY: 'busy',
    NOT_FOUND: 'not-found',
    NO_RESULT: 'no-result',
    NO_CLINIC: 'no-clinic',
    FAILED: 'failed',
};

/*
 * The "Save & Send to Patient" branch is on hold until product finalises the patient email copy
 * below — we don't want a placeholder message landing in a real patient's inbox. Flipping this to
 * true restores the whole branch: SaveStep's share mode and DoneStep's Send/Go to Messages are
 * left intact and simply unreachable while it's false.
 */
export const SHARE_TO_PATIENT_ENABLED = false;

// ponytail: placeholder copy — real template pending from product.
export const DEFAULT_PATIENT_MESSAGE = {
    subject: 'Your Smile Preview Is Ready',
    message: 'Your smile preview is ready — reply to this email to hear more from us.',
};

export const PRIMARY_BUTTON =
    'w-full h-11 inline-flex items-center justify-center gap-2 bg-[#2D2D2D] text-white rounded-lg hover:bg-[#1A1A1A] active:bg-[#111111] transition-colors disabled:bg-[#E8E6E3] disabled:text-[#B0ADA8] disabled:cursor-not-allowed';

export const SECONDARY_BUTTON =
    'w-full h-11 inline-flex items-center justify-center gap-2 bg-white text-[#2D2D2D] border border-[#E8E6E3] rounded-lg hover:bg-[#FAFAF9] transition-colors';

export const QUIET_BUTTON =
    'w-full h-11 text-sm text-[#6B6B6B] hover:text-[#2D2D2D] transition-colors';

export const MICRO_LABEL = 'font-dashboard text-[10px] uppercase tracking-[0.5px]';

export const INPUT_CLASSES =
    'w-full px-4 py-3 bg-white border border-[#E8E6E3] rounded-lg text-[#2D2D2D] placeholder:text-[#B0ADA8] focus:outline-none focus:ring-2 focus:ring-[#38433A]';
